'use client'

import dynamic from 'next/dynamic'
import { Button } from 'react-aria-components'

import Modal from '@/components/modal/Modal'
import Icon from '@/components/ui/icon'
import Loader from '@/components/ui/Loader'

const AutocompleteWidget = dynamic(
  () => import('@/components/search/autocomplete/AutocompleteWidget'),
  {
    loading: () => <ModalLoader />,
  },
)

function ModalLoader() {
  return (
    <div className="mb-l text-center">
      <Loader size="small" />
    </div>
  )
}

function ModalLauncher() {
  return (
    <Button className="text-black hover:text-primary" aria-label="Open the website search">
      <Icon id="icon-search" width={18} height={18} />
    </Button>
  )
}

export default function GlobalSiteSearch() {
  return (
    <Modal
      title="Search website"
      subtitle="Please use the search bar below to find what you're looking for."
      trigger={<ModalLauncher />}>
      <div className="p-m ms:p-s">
        <AutocompleteWidget />
      </div>
    </Modal>
  )
}
